import React from "react";
import { Box, Flex, Text } from "rebass";
import { Backdrop, Block, Overlay, styled } from "reakit";

const HealthSubmission = (props) => {
  const { visible, toggle, profile, isFaculty, healthy } = props;
  const NewBackdrop = styled(Backdrop)`
    z-index: 9999 !important;
  `;

  const HEALTHY =
    "Proceed with your day :)";

  const UNHEALTHY_DAY = `
  If you answered yes to any of the questions, stay in your dormitory room and call the Wellness Center for further instruction.
  `
    .split("\n")
    .map((item, i) => <p key={i}>{item}</p>);

  const UNHEALTHY_BOARDING = `
  If you answered yes to any of the questions, stay in your dormitory room and call the Wellness Center for further instruction.
  `
    .split("\n")
    .map((item, i) => <p key={i}>{item}</p>);

  const FACULTY = `
  Stay home.\n
  Notify your supervisor and Heather Gelting.\n
  Call your primary care provider for evaluation.
  `
    .split("\n")
    .map((item, i) => <p key={i}>{item}</p>);

  return (
    <Overlay.Container>
      {(overlay) => (
        <Block>
          <NewBackdrop
            fade
            use={Overlay.Hide}
            {...overlay}
            visible={visible}
            onClick={toggle}
          />
          <Overlay fade {...overlay} visible={visible} width={"80vw"}>
            <Flex flexDirection={"column"} justifyContent={"space-between"}>
              {profile ? (
                <Box>
                  <Text textAlign={"center"}>
                    {healthy
                      ? HEALTHY
                      : isFaculty
                      ? FACULTY
                      : profile.is_boarding
                      ? UNHEALTHY_BOARDING
                      : UNHEALTHY_DAY}
                  </Text>
                </Box>
              ) : (
                <Box>
                  <Text color="meta" textAlign={"center"}>
                    Loading...
                  </Text>
                </Box>
              )}
            </Flex>
          </Overlay>
        </Block>
      )}
    </Overlay.Container>
  );
};

export default HealthSubmission;
